import { getFsValueUseCase } from '../get-fs-value/get-fs-value.use-case';

export const getMonthlyPackagesRangeUseCase = () =>
  getFsValueUseCase('enable_monthly_packages_range');

export default { getMonthlyPackagesRangeUseCase };
